(() => {
  const stylesheet = document.querySelector('[data-polygons-brand-fonts]');
  if (!stylesheet || !document.fonts) return;
  let started = false;
  const activate = async () => {
    if (started) return;
    started = true;
    stylesheet.media = 'all';
    try {
      const faces = await Promise.all([400, 500, 700].map(async weight => {
        const loaded = await document.fonts.load(`${weight} 1em "brother-1816"`);
        if (weight === 700 && loaded.length > 0) document.documentElement.classList.add('polygons-brand-heading-ready');
        return loaded;
      }));
      if (faces.every(result => result.length > 0)) document.documentElement.classList.add('polygons-brand-font-ready');
    } catch { /* Keep readable fallback fonts if the external kit is unavailable. */ }
  };
  if (stylesheet.sheet) activate();
  else stylesheet.addEventListener('load', activate, { once: true });
})();
